import {PrototypeCommunicator} from '@fantasmagames/slot/src/logic/prototype/PrototypeCommunicator';

export class GamePrototypeCommunicator extends PrototypeCommunicator {

	constructor() {
		super();

		this.options.path = '/simserver/Init?g=pendingwilds';
		this.gameID = 'pendingwilds';
	}

	protected addCheatToSpin(): void {
		super.addCheatToSpin();

		if ((window as any).cheatAdditionalData && (window as any).cheatAdditionalData.length > 0) {
			this.options.path += (window as any).cheatAdditionalData;
		}

		if ((window as any).cheat) {
			this.options.path += (window as any).cheatPath;
		}
	}
}



// WEBPACK FOOTER //
// ./src/logic/prototype/GamePrototypeCommunicator.ts